import { z } from 'zod';
import { NoteSchema } from '../base/note.js';
const DatabaseArtifactsSchema = z.object({
    PK: z.string(),
    SK: z.string(),
});
export const DatabaseNoteSchema = NoteSchema.merge(DatabaseArtifactsSchema);
